module.exports = __webpack_public_path__ + "static/media/thumb-1920-667676.63df9417.jpg";